<template>
  <poptip
    popper-class="user-feedback-modal"
    :word-wrap="true"
    @on-popper-show="showPoptip"
    class="user-feedback"
    placement="bottom"
    width="540"
  >

    <taskbar-button
      icon="md-warning"
      size="24"
      :show-badge="isNew"
      :click-handler="() => {}"
      tooltip-content="Исправления"
    />

    <div class="user-feedback-pop" slot="content">
      <tabs>
        <tab-pane label="Мои" >
          <feedback-list type="to_me" />
        </tab-pane>
        <tab-pane label="Назначенные мной" >
          <feedback-list type="from_me" />
        </tab-pane>
      </tabs>
    </div>
  </poptip>
</template>

<script>
import TaskbarButton from '@/components/parts/taskbar-button'
import FeedbackList from '@/components/feedback/feedback-list'

export default {
  components: {
    TaskbarButton,
    FeedbackList
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    isNew () {
      return this.$store.state.activeTasks.myTasks
    }
  },
  methods: {
    async showPoptip () {

    }
  }
}
</script>

<style lang="less">
.user-feedback {
  margin-right: 8px;
}

.user-feedback-modal {
  .ivu-poptip-body {
    padding: 16px;
  }
  .ivu-poptip-arrow {
    display: none;
  }
  .ivu-poptip-body-content-word-wrap {
    text-align: left;
    white-space: normal;
  }
}
</style>
